import * as Types from '../gql/types2';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {"context":{"clientName":"graphql2"}} as const;
export type MarkAllReadNotificationMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type MarkAllReadNotificationMutation = { __typename?: 'MutationModel', notifications: { __typename?: 'AppNotificationMutationModel', markAllRead: { __typename?: 'ValidationResponse', errors: Array<{ __typename?: 'ValidationError', message: string, argumentName?: string | null }> } } };


export const MarkAllReadNotificationDocument = gql`
    mutation MarkAllReadNotification {
  notifications {
    markAllRead {
      errors {
        message
        argumentName
      }
    }
  }
}
    `;
export type MarkAllReadNotificationMutationFn = Apollo.MutationFunction<MarkAllReadNotificationMutation, MarkAllReadNotificationMutationVariables>;

/**
 * __useMarkAllReadNotificationMutation__
 *
 * To run a mutation, you first call `useMarkAllReadNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAllReadNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAllReadNotificationMutation, { data, loading, error }] = useMarkAllReadNotificationMutation({
 *   variables: {
 *   },
 * });
 */
export function useMarkAllReadNotificationMutation(baseOptions?: Apollo.MutationHookOptions<MarkAllReadNotificationMutation, MarkAllReadNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkAllReadNotificationMutation, MarkAllReadNotificationMutationVariables>(MarkAllReadNotificationDocument, options);
      }
export type MarkAllReadNotificationMutationHookResult = ReturnType<typeof useMarkAllReadNotificationMutation>;
export type MarkAllReadNotificationMutationResult = Apollo.MutationResult<MarkAllReadNotificationMutation>;
export type MarkAllReadNotificationMutationOptions = Apollo.BaseMutationOptions<MarkAllReadNotificationMutation, MarkAllReadNotificationMutationVariables>;